import { ChangeEvent } from 'react';
import classNames from 'classnames';

import Plus from 'assets/icons/plus.svg';
import Minus from 'assets/icons/minus.svg';
import Message from 'types/Message';
import { FormattedMessage } from 'utils/intl';

import classes from './InputQuantity.module.scss';
import messages from './InputQuantity.messages';

type Props = {
  name: string;
  value: number;
  label?: Message;
  className?: string;
  minValue?: number;
  maxValue?: number;
  onChange: (args: { value: number }) => void;
  onBlur?: () => void;
  onIncrease: () => void;
  onDecrease: () => void;
  onDecreaseUnderMin?: () => void;
};

const InputQuantity = ({
  name,
  className,
  value,
  minValue = 1,
  maxValue = 99,
  label = <FormattedMessage {...messages.inputQuantity} />,
  onChange,
  onBlur,
  onIncrease,
  onDecrease,
  onDecreaseUnderMin,
}: Props): JSX.Element => {
  const isMinValue = minValue >= value;
  const isMaxValue = maxValue <= value;
  const disabledMinus = isMinValue || typeof value !== 'number';
  const disabledPlus = isMaxValue || typeof value !== 'number';

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const inputValue = Number(e.target.value);
    onChange({ value: Math.min(Math.max(minValue, inputValue), maxValue) });
  };

  return (
    <div
      className={classNames(classes.wrapper, className, classes.wrapperHorizontal)}
      onClick={(e) => e.stopPropagation()}
    >
      <div className={classes.iconWrapper} onClick={() => (!disabledMinus ? onDecrease() : onDecreaseUnderMin?.())}>
        <Minus
          className={classNames(classes.icon, {
            [classes.disabled]: disabledMinus && !onDecreaseUnderMin,
          })}
        />
      </div>
      <label htmlFor={name} className={classes.inputContainer}>
        <input
          id={name}
          name={name}
          type="number"
          data-eid="input-quantity"
          className={classes.input}
          min={minValue}
          max={maxValue}
          value={Number.isNaN(value) ? '' : value}
          onChange={handleChange}
          onBlur={onBlur}
        />
        <p className={classes.label}>{label}</p>
      </label>
      <div className={classes.iconWrapper} onClick={() => !disabledPlus && onIncrease()}>
        <Plus
          className={classNames(classes.icon, {
            [classes.disabled]: disabledPlus,
          })}
        />
      </div>
    </div>
  );
};

export default InputQuantity;
